// angular.module('HeroPRO').filter('numMask',

export default function NumMaskFilter() {
    return function numMaskFilter(number, visibleNumbers) {
        let length = 0;
        let maskedNumber = '';
        let numMaskedDigits = 0;
        const defaultVisibleNumbers = 3;
        let maskChars = '';
        let i = 0;

        if (!number) { return ''; }

        const value = number.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return number;
        }

        length = number.length;
        if (visibleNumbers !== undefined && visibleNumbers !== null && visibleNumbers > 1) {
            numMaskedDigits = length - Number(visibleNumbers);
            maskedNumber = number.toString().substring(numMaskedDigits);
            for (i = 0; i < numMaskedDigits; i++) {
                maskChars += '*';
            }
        } else {
            numMaskedDigits = length - defaultVisibleNumbers;
            maskedNumber = number.toString().substring(numMaskedDigits);
            for (i = 0; i < numMaskedDigits; i++) {
                maskChars += '*';
            }
        }
        maskedNumber = maskChars + maskedNumber;

        return maskedNumber;
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/numericMask.filter.js